import React, { useState } from 'react';
import './WrapperAutorizationStyle.scss';

const WrapperAutorization = ({ children }: any) => {
  return <div className="wrapper_autorization">{children}</div>;
};
export default WrapperAutorization;
